import Polyglot from 'node-polyglot';

/* global window */
// export default new Polyglot(window.mgf._i18n);

const polyglot = new Polyglot(window.mgf._i18n);

export default polyglot;

// export default {
//    t: (key, dict) => {
//        //console.log('KEY', key, polyglot.t(key, dict));
//        return key ? polyglot.t(key, dict) : key
//    },
// }
